import type { ReactNode } from "react";

type Tone =
  | "neutral"
  | "forest"
  | "coral"
  | "butter"
  | "good"
  | "warn"
  | "bad"
  | "sky";

const TONES: Record<Tone, { bg: string; fg: string }> = {
  neutral: { bg: "var(--bg-2)", fg: "var(--ink-2)" },
  forest: { bg: "#E5EBE2", fg: "var(--forest)" },
  coral: { bg: "#F9E2D7", fg: "var(--coral)" },
  butter: { bg: "#F8EBC4", fg: "#8B6420" },
  good: { bg: "#E1ECDA", fg: "var(--good)" },
  warn: { bg: "#F6E6C2", fg: "var(--warn)" },
  bad: { bg: "#F1D9D2", fg: "var(--bad)" },
  sky: { bg: "#DDE9EE", fg: "#3F6B7E" },
};

interface Props {
  children: ReactNode;
  tone?: Tone;
  size?: "sm" | "md";
  "data-testid"?: string;
}

export function Pill({
  children,
  tone = "neutral",
  size = "md",
  "data-testid": testId,
}: Props) {
  const t = TONES[tone];
  const sz =
    size === "sm"
      ? { padding: "2px 8px", fontSize: 11 }
      : { padding: "4px 10px", fontSize: 12 };
  return (
    <span
      data-testid={testId}
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 4,
        borderRadius: 999,
        background: t.bg,
        color: t.fg,
        fontWeight: 600,
        letterSpacing: 0.1,
        ...sz,
      }}
    >
      {children}
    </span>
  );
}
